module.exports = __webpack_public_path__ + "email-white.svg?00e2f948fa11a43acb12a855fd3cde5a";